<template>
  <div class="app">
      <v-card>
        <!-- <v-btn small color="success" @click="check">Check</v-btn> -->
        <v-container fluid grid-list-lg>
          <div v-bind="text" class="font-weight-thin title">Ques: {{text.question}}</div> 
          <v-layout row>
            <v-flex xs6>
              <v-card-title class="title">Frequency Table</v-card-title>
                <v-data-table
                    :headers="headers"
                    :items="project_budget"
                    hide-actions
                    :expand="true"
                    :disable-initial-sort="true"
                    class="elevation-1"
                    dark
                >
                    <template v-slot:items="props">
                    <td>{{ props.item.option }}</td>
                    <td class="text-xs-right">{{props.item.count}}</td>
                    <td class="text-xs-right">{{props.item.percent}}</td>
                    </template>
                </v-data-table>
            </v-flex>
            <v-flex xs6>
              <v-card-title class="title">Bar Chart</v-card-title>
                <VueApexCharts type="bar" height="350" :options="chart.bar.chartOptions" :series="chart.bar.series"></VueApexCharts>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  props:['dataset'],
  name: "Chart",
  components: {
    VueApexCharts,
  },
  data: function() {
    return {
        headers: [
            { text: "Option", value: "option", sortable: false, class: "title success white--text"},
            { text: "Count", value: "count", align: "right", class: "title success white--text" },
            { text: 'Ptg (%)', value: 'percentage', align: 'right', class: "title success white--text" },
        ],
        project_budget: [],
        text:{
          question:null
        }, 
        chart: {
        bar: {
          series: [{
            data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380]
          }],
          chartOptions: {
            chart: {
              type: 'bar',
              height: 350
            },
            plotOptions: {
              bar: {
                borderRadius: 4,
                horizontal: false,
              }
            },
            dataLabels: {
              enabled: false
            },
            xaxis: {
              categories: [],
            }
          },
        }
      }
    }; 
  },

  watch: {
    dataset: function(){
      this.initialize()  
    }
  },

  created () {
      this.initialize()
  },

  methods: {
      initialize () {
        this.chart.bar.chartOptions = {
            xaxis:{
              categories: this.dataset.graphData.labels,
            }
          };
          this.chart.bar.series=[{
            data:this.dataset.graphData.series
          }];
          this.project_budget=this.dataset.datas;
          this.text.question = this.dataset.queSet.question;
      },
      check(){
        // console.log(this.dataset);
        // console.log(this.chart.pie.options);
      }
  }
};
</script>

<style>
#chart3 {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
